import React from 'react'
import { View, StyleSheet } from 'react-native'

interface ProgressBarProps {
  percentage: number
  color: string
  backgroundColor?: string
  height?: number
  borderRadius?: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage,
  color,
  backgroundColor = 'rgba(0, 0, 0, 0.1)',
  height = 6,
  borderRadius = 3,
}) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100)

  return (
    <View
      style={[
        styles.container,
        {
          height,
          backgroundColor,
          borderRadius,
        },
      ]}
    >
      <View
        style={[
          styles.fill,
          {
            width: `${clampedPercentage}%`,
            backgroundColor: color,
            borderRadius,
          },
        ]}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
  fill: {
    height: '100%',
  },
})
